import { FETCH_TICKETS, FETCH_TICKETS_SUCCESS, FETCH_TICKETS_FAIL } from './actionTypes';

export const fetchTickets = (params = {}) => ({
  type: FETCH_TICKETS,
  payload: params
});

export const fetchTicketsSuccess = (tickets) => ({
  type: FETCH_TICKETS_SUCCESS,
  payload: tickets,
});

export const fetchTicketsFail = (error) => ({
  type: FETCH_TICKETS_FAIL,
  payload: error,
});
